import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

// Ligne compacte (style legacy VB6) : label largeur fixe à gauche, contrôle à droite.
// Utilisée dans Identification et Méga pour minimiser le défilement vertical.
// Labels en MAJUSCULES + GRAS pour un meilleur contraste visuel.
export const Row = ({ label, required, hint, children }) => (
    <div className="flex items-start gap-3 py-1">
        <Label className="w-44 shrink-0 pt-2 text-[13px] uppercase font-bold tracking-wide text-slate-900 leading-tight">
            {label}
            {required && <span className="text-red-600 ml-0.5">*</span>}
        </Label>
        <div className="flex-1 min-w-0">
            {children}
            {hint && <p className="text-[10px] text-slate-500 mt-0.5">{hint}</p>}
        </div>
    </div>
);

// Ligne toggle compacte : label à gauche, switch à droite.
export const ToggleRow = ({ k, label, locked = false, checked, onChange, disabled }) => (
    <div className={`flex items-center justify-between gap-3 py-1 ${locked ? "opacity-50" : ""}`}>
        <Label className="text-[13px] uppercase font-bold tracking-wide text-slate-900">{label}</Label>
        <Switch
            checked={checked}
            onCheckedChange={onChange}
            disabled={disabled || locked}
            data-testid={k ? `avocat-switch-${k}` : undefined}
        />
    </div>
);

// Classe utilitaire pour les sous-titres de section (LANGUES, ARTICLES HABILITÉS, etc.)
export const sectionTitleCls = "text-[12px] uppercase tracking-wider font-bold text-slate-800 mb-1";

// Classes utilitaires pour inputs compacts (h-8 pour matcher le rendu legacy)
export const compactInputCls = "rounded-md h-8 text-sm";
export const compactInputMonoCls = "rounded-md h-8 text-sm font-mono";
